import { takeEvery } from 'redux-saga/effects';

import * as authActionTypes from 'store/modules/auth';
import { signInSuccess } from './utils';

export default function* listenSignIn() {
  yield takeEvery(authActionTypes.signInActions, signInSuccess);
}
